/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorizedSellerContact
 */
export interface AuthorizedSellerContact {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedSellerContact
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedSellerContact
     */
    lastname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedSellerContact
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedSellerContact
     */
    phone?: string | null;
}

export function AuthorizedSellerContactFromJSON(json: any): AuthorizedSellerContact {
    return AuthorizedSellerContactFromJSONTyped(json, false);
}

export function AuthorizedSellerContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizedSellerContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'lastname': !exists(json, 'lastname') ? undefined : json['lastname'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function AuthorizedSellerContactToJSON(value?: AuthorizedSellerContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'lastname': value.lastname,
        'email': value.email,
        'phone': value.phone,
    };
}

